import DialogWithCloseIcon from '@/components/ui/dialogs/dialog-with-close-icon';
import Chat from '..';
import {useMatrixRoomContext} from '@/contexts/matrix/room';
type ChatWindowProps = {
  open: boolean;
  onClose: () => void;
  userName?: string | null;
};

const ChatWindow: React.FC<ChatWindowProps> = ({open, onClose, userName}) => {
  const {userDialogOpen} = useMatrixRoomContext();

  return (
    <DialogWithCloseIcon
      hide={userDialogOpen}
      open={open}
      onClose={onClose}
      chatUserName={userName}
      isChatWindow
    >
      <Chat />
    </DialogWithCloseIcon>
  );
};

export default ChatWindow;
